// TODO those utilities are very coupled.
import { getStore } from '../../../app/state/storeRegistry'
import { Edge, Node } from 'reactflow'
import { WorkflowNodeData, WorkflowNodeSourceDOData, WorkflowSchemaDataModel } from '../types'

interface WorkflowSource {
  edges: Edge[]
  nodes: Node<WorkflowNodeData | WorkflowNodeSourceDOData>[]
  id: string
  parent?: string
}

export const workflowSource = ({ edges, nodes, id, parent = 'source' }: WorkflowSource) => {
  const edge = edges.find((edge) => edge.targetHandle === parent && edge.target === id)

  if (!edge) return

  return nodes.find((node) => node.id === edge.source)
}

interface IsDOSource {
  edges: Edge[]
  nodes: Node<WorkflowNodeData>[]
  id: string
  parent?: string
}

export const isDOSource = ({ edges, nodes, id, parent }: IsDOSource) => {
  const source = workflowSource({ edges, nodes, id, parent })

  return source?.type === 'SourceDO'
}

export function getSchemaForNode({ aggregationMethods, nodeId }) {
  const node: WorkflowSchemaDataModel | undefined = getStore().getState().workflows?.schemas?.[nodeId]
    ?.data?.[0] as WorkflowSchemaDataModel

  if (!node) return

  return aggregationMethods ? node.schema?.filter((s) => Boolean(aggregationMethods[s.type])) : node.schema
}

interface Params {
  nodeId: string
  parent: string
  edges: Edge[]
}

export const getSchemaFromParent = (params: Params) => {
  const edge = params.edges.find((edge) => edge.targetHandle === params.parent && edge.target === params.nodeId)

  if (!edge) return

  const node: WorkflowSchemaDataModel | undefined = getStore().getState().workflows?.schemas?.[edge.source]
    ?.data?.[0] as WorkflowSchemaDataModel

  if (!node) return

  return node.schema
}
